import {Component, OnInit} from '@angular/core';
import {ApiConfig, NodeBuilder} from "../../../../../../../shared/models";
import {FlowManagerService} from "../../../../../services/flow-manager.service";
import {Observable} from "rxjs";
import {tap} from "rxjs/internal/operators";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {HttpCallNode, KeyValue} from "./httpCall";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";

const NODE_TYPE = 'httpCall';

@Component({
    selector: 'app-http-call',
    templateUrl: './http-call.component.html',
    styleUrls: ['./http-call.component.scss']
})
export class HttpCallComponent extends NodeBuilder implements OnInit {

    apiDetails$: Observable<Map<string, ApiConfig>>;
    apiDetails: any;
    apiDetailNames: any = [];
    apiDetailNamesFilter: any = [];

    apiForm: FormGroup;
    readonly API_DETAILS_DISPLAY: string[] = ["elementValidation", "method", "poolName", "requestType", "responseType", "url"]

    hasLoading = false;

    constructor(private flowManagerService: FlowManagerService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
    }

    set buildForm(stepData: any) {
        this.apiForm = HttpCallNode.toForm(stepData, this.canEdit);
        this.apiDetails$ = this.flowManagerService.getApis().pipe(
            tap((apiDetails) => {
                this.apiDetailNames = Object.keys(apiDetails);
                this.apiDetailNamesFilter = Object.keys(apiDetails);
                this.apiDetails = apiDetails;
                this.hasLoading = true;
                this.add_missing_body();
            })
        );

        let results: FormArray = this.apiForm.get('result') as FormArray;
        for (let key in results.controls) {
            const result: FormControl = results.controls[key].get("value") as FormControl;
            if (result.value === newStepValue) {
                result.setValue('step' + this.getNextStep());
            }
        }
    }

    get getStepData(): {} {
        const node = new HttpCallNode();
        node.addActionParams(this.apiForm.getRawValue())
        return node.nodeData;
    }

    get isNodeValid(): boolean {
        this.apiForm.markAllAsTouched();
        return this.apiForm.valid && this.hasLoading;
    }

    public apiInput(apiName: string): void {
        this.apiDetailNamesFilter = this.apiDetailNames?.filter(option => option.toLowerCase().includes(apiName));
    }

    public addKeyValue(controlName: string): void {
        let formData = this.apiForm.get(controlName) as FormArray;
        formData.push(HttpCallNode.addKeyValue(this.canEdit.canEditFlows))
    }

    public deleteKeyValue(controlName: string, index: number): void {
        let formData = this.apiForm.get(controlName) as FormArray;
        formData.removeAt(index);
    }

    public addResult() {
        let results = this.apiForm.get('result') as FormArray;
        let keyValue: KeyValue = {
            key: "",
            value: newStepValue
        };
        results.push(HttpCallNode.addKeyValue(this.canEdit.canEditFlows, keyValue));
    }

    public apiSelected(apiName: string): void {
        this.apiForm.markAllAsTouched()
        const apiDetail = this.apiDetails[apiName];
        if (apiDetail) {
            let editFlows = this.canEdit.canEditFlows;

            let headers: FormArray = this.apiForm.get('headers') as FormArray;
            let queryStrings: FormArray = this.apiForm.get('queryStrings') as FormArray;
            headers.clear();
            queryStrings.clear()
            this.apiForm.removeControl("body");

            if (apiDetail['method'] === 'POST' || apiDetail['method'] === 'PUT') {
                if (apiDetail['requestType'] === 'multipart/form-data') {
                    this.apiForm.addControl("body", HttpCallNode.buildHttpBody({}, editFlows))
                } else {
                    this.apiForm.addControl("body", HttpCallNode.buildHttpBody("", editFlows))
                }
            }
        }
    }

    private add_missing_body() {
        if (!this.apiForm.get("body")) {
            const apiName = this.apiForm.get('apiName').value;
            const apiDetail = this.apiDetails[apiName];
            if (apiDetail) {
                let editFlows = this.canEdit.canEditFlows;
                if (apiDetail['method'] === 'POST' || apiDetail['method'] === 'PUT') {
                    if (apiDetail['requestType'] === 'multipart/form-data') {
                        this.apiForm.addControl("body", HttpCallNode.buildHttpBody({}, editFlows))
                    } else {
                        this.apiForm.addControl("body", HttpCallNode.buildHttpBody("", editFlows))
                    }
                }
            }
        }
    }
}
